<template>
  <div>
    <b-row>
      <b-col cols="9" class="mb-2"></b-col>

      <b-col class="mb-2">
        <b-button block variant="success" @click="addCurrency()" :disabled="!CREATE">Crear</b-button>
      </b-col>
    </b-row>

    <b-row class="mt-0">
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">

            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
            >

            <!-- <template v-slot:cell(date)="data"> -->
            <template slot="date" slot-scope="data">
              {{formatDate(data.item.date)}}
            </template>

              <template slot="actions" slot-scope="data">
                <!-- <template v-slot:cell(actions)="data"> -->
                <b-button
                  size="sm"
                  variant="primary"
                  class="mr-1 btn-custom-size"
                  @click="view(data.item)"
                  title="Ver"
                  :disabled="!READ"
                >
                  <i class="fa fa-eye"></i>
                </b-button>

                <b-button
                  size="sm"
                  variant="success"
                  class="mr-1 btn-custom-size"
                  @click="editCurrency(data.item)"
                  title="Editar"
                  :disabled="!UPDATE"
                >
                  <i class="fa fa-edit"></i>
                </b-button>
                <b-button
                  size="sm"
                  variant="danger"
                  class="btn-custom-size"
                  @click="deleteCurrency(data.item.id)"
                  title="Eliminar"
                  :disabled="!DELETE"
                >
                  <i class="fa fa-trash"></i>
                </b-button>
              </template>
            </b-table>
            <hr />
            <div class="row">
              <div
                class="col-sm-4"
              >Mostrando {{getRowCount(items) > (perPage * currentPage) ? perPage * currentPage : getRowCount(items)}} de {{getRowCount(items)}} registros</div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- MODAL PARA LAS DIVISAS -->
    <div class="modal fade" id="dlgCurrency">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">DIVISA</h4>
            <button type="button" class="close" @click="close()">&times;</button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="save" method="post" >
              <b-row>
                <b-col class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="warning">
                        <b>ADVERTENCIAS:</b>
                        <li class="ml-2" v-for="(error, index) in errores" :key="index">{{ error }}</li>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col >
                      <b-form-group>
                        <label for="cmbTipo">Tipo</label>
                        <b-form-select
                          v-model="currency.type"
                          id="cmbTipo"
                          :disabled="disabled"
                        >
                          <template slot="first">
                            <option
                              :value="null"
                              disabled
                            >-- Por favor seleccione una opción --</option>
                          </template>
                          <option
                            v-for="item in lstType"
                            :key="item.id"
                            :value="item.id"
                          >{{ item.name }}</option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtFecha">Fecha</label>
                        <b-form-input
                          type="date"
                          id="txtFecha"
                          v-model="currency.date"
                          :max="maxDate"
                          :disabled="disabled"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="txtValor">Valor (COP)</label>
                        <b-form-input
                          type="text"
                          id="txtValor"
                          v-model="currency.value"
                          :disabled="disabled"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabled" class="mt-2">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disabled"
                      >Guardar</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LAS DIVISAS -->
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Currency",
  props: {
    caption: {
      type: String,
      default: "Divisas",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      items: [],
      fields: [
        { key: "type_name", label: "Tipo" },
        { key: "date", label: "Fecha" },
        { key: "value", label: "Valor (COP)" },
        { key: "actions", label: "Opciones" },
      ],
      currentPage: 1,
      perPage: 10,
      lstType: [],
      currency: {},
      datos: {},
      errores: [],
      rowCount: -1,
      // PARA EL STAFF
      lstTipoDocumento: [],
      lstUsers: [],
      lstType: [],
      lstBranchOffices: [],
      //NUEVO
      isEdit: false,
      disabled: false,
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  mounted() {
    this.enabledActions();
    this.getData();
  },
  computed: {},
  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ   = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    getData() {
      showLoader();

      this.$http.get(`${this.$urlApi}currencies?token=${this.token}`)
        .then(
          (response) => {
            this.items = response.data.data;
            // console.log("currencies -------------------------------------------------------------> ",response);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getRowCount(items) {
      return items.length;
    },
    initParameters() {
      this.currency = {
        type: null,
        date: null,
        value: null
      };

      //19: TIPOS DE DIVISAS
      this.$http.get(`${this.$urlApi}parameters/19?token=${this.token}`).then(
        (response) => {
          this.lstType = response.data.data;
        },
        (error) => {
          console.log(error);
          alert(error.body.message);
        }
      );

    },
    addCurrency() {
      showLoader();
      this.initParameters();
      this.errores = [];
      $("#dlgCurrency").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEdit = false;
      hideLoader();
    },
    editCurrency(item) {

      console.log(item);
      showLoader();
      this.initParameters();
      this.errores = [];
      $("#dlgCurrency").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.currency = Object.assign({}, item);
      this.isEdit = true;
      $("#dlgCurrency").modal("show");
      hideLoader();
    },
    deleteCurrency(id) {
      this.$swal({
        title: "Eliminar",
        text: "Desea eliminar el registro!",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Aceptar",
      }).then((result) => {
        if (result.value) {
          showLoader();
          this.$http.delete(`${this.$urlApi}currencies/${id}?token=${this.token}`, 
            {headers: { "Content-Type": "application/json" },
            }).then(function (response) {
              hideLoader();
              this.$swal({
                title: "Buen trabajo",
                text: "Registro eliminado correctamente!",
                type: "success",
                showCancelButton: false,
                confirmButtonText: "Aceptar",
              }).then((result) => {
                if (result.value) {
                  this.getData();
                }
              });
            }).catch((error) => {
              console.log(error);
              hideLoader();
            });
        }
      });
    },
    view(item) {
      console.log(item);
      showLoader();
      this.initParameters();
      $("#dlgCurrency").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.currency = Object.assign({}, item);
      this.disabled = true;
      $("#dlgCurrency").modal("show");
      hideLoader();
    },
    save() {
      if (this.isEdit) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      showLoader();
      this.datos = JSON.stringify(this.currency);
      this.$http.post(`${this.$urlApi}currencies?token=${this.token}`, this.datos, 
        {headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);
          hideLoader();
          this.$swal({
            title: "Buen trabajo",
            text: "Registro guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.getData();
              $("#dlgCurrency").modal("hide");
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          console.log(error);
          hideLoader();
        });
    },
    update() {
      showLoader();
      let id = this.currency.id;
      this.datos = JSON.stringify(this.currency);
      this.$http.put(`${this.$urlApi}currencies/${id}?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);
          hideLoader();
          this.$swal({
            title: "Buen trabajo",
            text: "Registro actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.getData();
              $("#dlgCurrency").modal("hide");
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    close() {
      this.isEdit = false;
      this.disabled = false;
      $("#dlgCurrency").modal("hide");
    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },
  },
};
</script>
